<template>
  <div class="header">
    <div class="logo">
      <img src="../assets/images/logo.png" alt="" srcset="" style="width:116px;height:45px"/>
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 国际化 -->
        <el-dropdown class="user-I18n" @command="SET_LANG">
          <span class="el-dropdown-link button">
            {{ lang }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="EN">EN</el-dropdown-item>
            <el-dropdown-item command="CN">CN</el-dropdown-item>
            <el-dropdown-item command="TH">TH</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div style="position: relative;cursor: pointer;" @click="toShowNotify">
          <i class="el-icon-message-solid" style="font-size: 28px;padding-right: 8px"></i>
          <div v-if="notifyNum!==0" class="angleMark">{{notifyNum}}</div>
        </div>
        <!-- 用户头像 -->
        <div class="user-avator">
          <!-- <i class="iconfont icon-icon_denglu_zhanghao"></i> -->
          <img src="./../assets/images/head.png" alt="" style="width:28px;height:28px">
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            Hi, {{ user && user.name }} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="siteSetting">{{
                $lang("站点设置")
              }}</el-dropdown-item>
            <el-dropdown-item command="updatePwd">{{
                $lang("修改密码")
              }}</el-dropdown-item>
            <el-dropdown-item command="loginout">{{
                $lang("退出登录")
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog :title="$lang('修改密码')" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="ruleForm">
        <el-form-item :label="$lang('旧密码')" prop="oldPwd">
          <el-input :placeholder="$lang('请输入旧密码')" v-model="form.oldPwd" show-password></el-input>
        </el-form-item>

        <el-form-item :label="$lang('新密码')" prop="pwd">
          <el-input :placeholder="$lang('请输入新密码')" v-model="form.pwd" show-password></el-input>
        </el-form-item>

        <el-form-item :label="$lang('确认密码')" prop="confirmPwd">
          <el-input :placeholder="$lang('请输入确认密码')" v-model="form.confirmPwd" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$lang('取消')}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$lang('保存')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { loginOut, updatePwd } from "@public/api";
import {mapActions, mapGetters, mapMutations} from "vuex";
import { RESPONSE_SUCCESS } from "@public/utils/const";
import { AESUtil } from "../@public/utils/common";

export default {
  data() {
    var password = (rule, value, callback) => {
      if (!this.form.pwd) {
        callback(new Error(this.$lang('请输入密码')));
      } else {
        const pwdReg = new RegExp('^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)([^(0-9a-zA-Z)]|[a-z]|[A-Z]|[0-9]){6,12}')
        const isValid = pwdReg.test(this.form.pwd)
        if (isValid != true) {
          callback(new Error(this.$lang('6-12位字符并包含大小写字母、数字中的两种类型')));
        } else {
          callback()
        }
        callback()
      }
    };
    var confirmPassword = (rule, value, callback) => {
      if (!this.form.confirmPwd) {
        callback(new Error(this.$lang('请输入确认密码')));
      } else {
        if (this.form.pwd != this.form.confirmPwd) {
          callback(new Error(this.$lang('两次密码不一致，请重新输入')));
        } else {
          callback()
        }
      }
    }
    return {
      collapse: false,
      fullscreen: false,
      name: "linxin",
      message: 2,
      dialogFormVisible: false,
      labelPosition: 'top',
      form: {
        oldPwd: '',
        pwd: '',
        confirmPwd: ''
      },
      input: '',
      rules: {
        oldPwd: [
          { required: true, message: this.$lang('请输入旧密码'), trigger: 'blur' }
        ],
        pwd: [
          {
            required: true, validator: password, trigger: 'blur'
          }
        ],
        confirmPwd: [
          {
            required: true, validator: confirmPassword, trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["lang", "user", 'messageStatus', 'notifyNum'])
  },
  methods: {
    ...mapMutations(["SET_LANG", "LOGIN_OUT"]),
    ...mapActions(["GET_NOTIFICATION"]),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePwd({
            oldPwd: AESUtil.aesEncrypt(this.form.oldPwd),
            pwd: AESUtil.aesEncrypt(this.form.pwd)
          }).then((result) => {
            if (result.code == RESPONSE_SUCCESS) {
              this.$message.success(this.$lang("修改密码成功,重新登录即可生效"));
            }
          }).catch((err) => {
            console.log(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        loginOut({})
          .then((result) => {
            if (result.code == RESPONSE_SUCCESS) {
              this.$message.success(this.$lang("退出成功"));
              this.LOGIN_OUT();
              this.$router.push("/login");
            } else {
              this.$message.error(this.$lang("退出失败，请重试!"));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (command == 'siteSetting') {
        this.$router.push({
          path: '/setting'
        })
      } else if (command == 'updatePwd') {
        this.dialogFormVisible = true
      }
    },
    toShowNotify() {
      if (!this.messageStatus) {
        this.GET_NOTIFICATION(1)
      } else {
        this.$store.commit('SET_STATUS', false)
      }
    }
  }
};
</script>
<style scoped lang="scss">
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 22px;
  background: linear-gradient(41deg, #47B493 2%, #3BAB89 97%);
  color: $header-color;
  .logo {
    display: inline-block;
    // width: 200px;
    margin-left: 32px;
    height: 64px;
    //   color: #fff;
    text-align: center;
    line-height: 50px;
    img {
      vertical-align: middle;
    }
  }
}

.header-right {
  float: right;
  padding-right: 16px;
}
.header-user-con {
  display: flex;
  height: 64px;
  align-items: center;
}
.user-I18n {
  padding-right: 24px;
  position: relative;
}
.user-name {
  margin-left: 24px;
}
.user-avator {
  margin-left: 16px;
  .iconfont {
    font-size: 20px;
    color: #ffffff;
    border-radius: 19px;
    // background: #d2d2d2;
    // border: 1px solid #e7e7f0;
  }
}
.el-dropdown {
  color: #fff;
}
.el-dropdown-link {
  font-size: 14px;
  cursor: pointer;
  .el-icon-caret-bottom {
    font-size: 6px;
  }
}
.button{
  display: inline-block;
  width: 56px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border-radius: 20px;
  color: #3BAB89;
  text-align: center;
}
.el-dropdown-menu__item {
  text-align: center;
}

.el-button{
  padding: 8px 20px;
}
.angleMark {
  background: #fb0000;
  border-radius: 50%;
  font-size: 14px;
  padding: 1px 5px;
  text-align: center;
  line-height: 1.1;
  top: 0;
  position: absolute;
  right: 0;
  transform: translate(-4px, -2px);
}
</style>
